import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type IndicatorWithId = {
  idIndicator: number;
};

// Базовый тип для create/update операций индикаторов
type IndicatorCreateUpdateData = IndicatorWithId & {
  name: string;
  math: string;
};

// Типы для WebSocket сообщений компонента indicators
type IndicatorRootMessage = WebSocketMessageWithFields<'indicator-root' | 'indicator-out-list' | 'indicator-set-list' | 'indicator-param-list', {
  indicator: {
    idIndicator: number;
    name: string;
    math: string;
    locked: boolean;
  };
}>;
type IndicatorRootNotFoundMessage = WebSocketMessageEmpty<'indicator-root-not-found'>;
type IndicatorListMessage = WebSocketMessageWithFields<'indicator-list' | 'global-pair-indicator' | 'pair' | 'calc-info', {
  indicators: unknown[];
}>;
type IndicatorCreateMessage = WebSocketMessageWithFields<'indicator-create' | 'indicator-create-success', IndicatorCreateUpdateData>;
type IndicatorUpdateMessage = WebSocketMessageWithFields<'indicator-update' | 'indicator-update-success', IndicatorCreateUpdateData>;
type IndicatorDeleteMessage = WebSocketMessageWithFields<'indicator-delete' | 'indicator-delete-success', IndicatorWithId>;
type IndicatorLockMessage = WebSocketMessageWithFields<'indicator-lock' | 'indicator-lock-success', IndicatorWithId>;
type IndicatorUnlockMessage = WebSocketMessageWithFields<'indicator-unlock' | 'indicator-unlock-success', IndicatorWithId>;

// Объединенный тип для всех сообщений
type IndicatorsWebSocketMessage = 
  | IndicatorRootMessage 
  | IndicatorRootNotFoundMessage 
  | IndicatorListMessage 
  | IndicatorCreateMessage 
  | IndicatorUpdateMessage 
  | IndicatorDeleteMessage 
  | IndicatorLockMessage 
  | IndicatorUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataIndicators',
},
  __name: 'indicators',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID индикатора
const handleWebSocketMessage = (data: IndicatorsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-root':
    case 'indicator-out-list':
    case 'indicator-set-list':
    case 'indicator-param-list':
      store.dispatch('indicator/wsSetIndicator', {
        idIndicator: data.indicator.idIndicator,
        name: data.indicator.name,
        math: data.indicator.math,
        locked: data.indicator.locked,
      });
      break;
    case 'indicator-root-not-found':
      store.dispatch('indicator/wsSetEmptyIndicator');
      break;

    case 'indicator-list':
    case 'global-pair-indicator':
    case 'pair':
    case 'calc-info':
      store.dispatch('indicators/wsSetIndicators', { indicators: data.indicators });
      break;

    case 'indicator-create':
    case 'indicator-create-success':
      store.dispatch('indicators/wsIndicatorCreate', {
        idIndicator: data.idIndicator,
        name: data.name,
        math: data.math,
      });
      break;

    case 'indicator-update':
    case 'indicator-update-success':
      store.dispatch('indicators/wsIndicatorUpdate', {
        idIndicator: data.idIndicator,
        name: data.name,
        math: data.math,
      });
      store.dispatch('indicator/wsIndicatorUpdate', {
        idIndicator: data.idIndicator,
        name: data.name,
        math: data.math,
      });
      break;

    case 'indicator-delete':
    case 'indicator-delete-success':
      store.dispatch('indicators/wsIndicatorDelete', {
        idIndicator: data.idIndicator,
      });
      store.dispatch('indicator/wsIndicatorDelete', {
        idIndicator: data.idIndicator,
      });
      break;

    case 'indicator-lock':
    case 'indicator-lock-success':
      store.dispatch('indicators/wsIndicatorLock', {
        idIndicator: data.idIndicator,
      });
      store.dispatch('indicator/wsIndicatorLock', {
        idIndicator: data.idIndicator,
      });
      break;

    case 'indicator-unlock':
    case 'indicator-unlock-success':
      store.dispatch('indicators/wsIndicatorUnlock', {
        idIndicator: data.idIndicator,
      });
      store.dispatch('indicator/wsIndicatorUnlock', {
        idIndicator: data.idIndicator,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})